import React, { useCallback, useState } from 'react';
import {
  AMM_COOKIE_POLICY_URL,
  AMM_PRIVACY_URL,
  AMM_TERMS_URL,
} from '../../data/numerologyLegalLinks';
import './NumerologyLegalShell.css';

/**
 * Small legal footer for all Numerology shell surfaces (hub, course, report, gate).
 */
export default function NumerologyLegalFooter() {
  const [busy, setBusy] = useState(false);

  const onCourseSignOut = useCallback(async () => {
    if (busy) return;
    setBusy(true);
    try {
      await fetch('/api/numerology-logout', {
        method: 'POST',
        credentials: 'include',
        headers: { Accept: 'application/json' },
      });
    } catch {
      /* still navigate to clear client state */
    }
    window.location.assign('/numerology/study');
  }, [busy]);

  const linkProps = {
    target: '_blank',
    rel: 'noopener noreferrer',
    className: 'amm-num-legal-footer__link',
  };

  return (
    <footer className="amm-num-legal-footer" aria-label="Legal">
      <p className="amm-num-legal-footer__lines">
        Astral Moon Magic © {new Date().getFullYear()}
        <br />
        Educational &amp; spiritual content only.
        <br />
        No guaranteed results.
      </p>
      <nav className="amm-num-legal-footer__nav" aria-label="Legal links">
        <a href={AMM_TERMS_URL} {...linkProps}>
          Terms of Service
        </a>
        <span className="amm-num-legal-footer__sep" aria-hidden>
          ·
        </span>
        <a href={AMM_PRIVACY_URL} {...linkProps}>
          Privacy Policy
        </a>
        <span className="amm-num-legal-footer__sep" aria-hidden>
          ·
        </span>
        <a href={AMM_COOKIE_POLICY_URL} {...linkProps}>
          Cookie Policy
        </a>
      </nav>
      <p className="amm-num-legal-footer__signout-wrap">
        <button
          type="button"
          className="amm-num-legal-footer__signout"
          onClick={onCourseSignOut}
          disabled={busy}
        >
          {busy ? 'Signing out…' : 'Sign out of course area'}
        </button>
      </p>
    </footer>
  );
}
